import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import LogoDark  from '../../../assets/images/logos/logo-full-light.png';
import LogoLight from '../../../assets/images/logos/logo-full.png';

const LogoIcon = () => {
  const customizer = useSelector((state) => state.ui_store);
  return (
    <Link underline="none" to="/" style={{ display: 'block', textAlign: 'center' }}>
      {customizer?.activeMode === 'dark' ? <img src={LogoDark} alt='logo' width={100} /> : <img src={LogoLight} alt='logo' width={100} />}

    </Link>
  );
};

export default LogoIcon;
